import { __assign, __read } from "tslib";
import React, { useState, useEffect } from 'react';
import { motion, useAnimation, AnimatePresence } from 'framer-motion';
import { Mark as PointMark, markMotion } from '../../../../components';
import { AnimationVariants } from './types';
var createPointMotion = function (isActive) {
    var _a;
    return (_a = {},
        _a[AnimationVariants.Hidden] = { opacity: 0 },
        _a[AnimationVariants.Visible] = { opacity: 1 },
        _a[AnimationVariants.Active] = {
            opacity: isActive ? 1 : 0.2,
            transition: isActive ? { delay: 0.2, duration: 0.3 } : { duration: 0.3 },
        },
        _a);
};
var pointTransition = { duration: 0.3, delay: 0.2 };
var Marks = function (_a) {
    var marks = _a.marks, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, curve = _a.curve, colorPalette = _a.colorPalette, stackMode = _a.stackMode, groupMode = _a.groupMode, activeKey = _a.activeKey;
    var _b = __read(useState(false), 2), initialDrawFinished = _b[0], setInitialDraw = _b[1];
    var marksControls = useAnimation();
    var _c = __read(useState(null), 2), activeMark = _c[0], setActiveMark = _c[1];
    useEffect(function () {
        if (initialDrawFinished) {
            setInitialDraw(false);
        }
        marksControls
            .start(AnimationVariants.Visible, { delay: 1.2, duration: 0.3 })
            .then(function () {
            setInitialDraw(true);
        });
    }, [marks.length, colorPalette, curve, groupMode, stackMode]);
    useEffect(function () {
        if (activeKey) {
            marksControls.start(AnimationVariants.Active).then(function () {
                setInitialDraw(true);
            });
        }
        else if (initialDrawFinished) {
            marksControls.start(AnimationVariants.Visible, {
                delay: 0.4,
                duration: 0.3,
            });
        }
    }, [activeKey]);
    return (React.createElement(React.Fragment, null, marks.map(function (mark) {
        var key = mark.key, dataSerieKey = mark.dataSerieKey, color = mark.color, radius = mark.radius, x = mark.x, y = mark.y;
        return (React.createElement("g", { key: key, onMouseEnter: function (e) {
                onMouseEnter(e, mark);
                setActiveMark(key);
            }, onMouseLeave: function (e) {
                onMouseLeave(e);
                setActiveMark(null);
            } },
            React.createElement(motion.circle, { key: key + "-" + curve + "-" + stackMode + "-" + groupMode, cx: x, cy: y, r: radius, fill: color, initial: AnimationVariants.Hidden, animate: marksControls, variants: createPointMotion(activeKey === dataSerieKey), transition: pointTransition }),
            React.createElement(AnimatePresence, null, activeMark === key && (React.createElement(motion.g, __assign({}, markMotion),
                React.createElement(PointMark, { x: x, y: y, color: color }))))));
    })));
};
export default Marks;
